/* AUTO-GENERATED from packages/melo-catalog — do not edit by hand */
(function (global) {
    'use strict';
    global.MELO_APPS_CATALOG_BY_LOCALE = {
    "es": {
        "apps": [
            {
                "slug": "tarifas-envio",
                "title": "Tarifas de envío",
                "subtitle": "Muestra precios de envío distintos por ciudad o código postal en el checkout — más allá del límite nativo de Shopify por estado.",
                "description": "Shopify solo permite tarifas de envío a nivel de estado. Con esta app defines zonas y subzonas (ciudades o códigos postales), creas las tarifas en tu tienda y filtras en checkout cuál aplica según la dirección del comprador. Configura manualmente o importa miles de precios con CSV. Ideal para cobertura geográfica detallada sin depender solo de transportistas externos.",
                "shortDescription": "Muestra precios de envío distintos por ciudad o código postal en el checkout — más allá del límite nativo de Shopify por estado.",
                "iconName": "delivery",
                "iconLetter": "D",
                "iconImage": "images/solutions/tarifas-envio/hero.png",
                "gallery": [
                    "images/solutions/tarifas-envio/screenshot-1.png"
                ],
                "category": "operations",
                "tag": "Shipping",
                "views": "",
                "searchKeywords": "Tarifas de envío Muestra precios de envío distintos por ciudad o código postal en el checkout — más allá del límite nativo de Shopify por estado. shipping orders",
                "searchImage": "images/solutions/tarifas-envio/hero.png",
                "searchExcerpt": "Muestra precios de envío distintos por ciudad o código postal en el checkout — más allá del límite nativo de Shopify por estado.",
                "featured": true,
                "showInHomeList": true,
                "showInSearch": true,
                "showInRelated": true,
                "homeListOrder": 1
            },
            {
                "slug": "selector-de-comunas",
                "title": "Selector de Comunas",
                "subtitle": "Permite que tus clientes elijan región y comuna en el carrito antes del checkout, con cobertura personalizable para Chile.",
                "description": "Agrega un selector nativo de región y comuna en el cart drawer y la página de carrito. Configura qué comunas ofreces, personaliza el diseño del widget, bloquea el checkout si falta la comuna y guarda la selección en los atributos del carrito para tarifas de envío y operación. Ideal para tiendas en Chile que necesitan capturar la ubicación del comprador antes de calcular envíos.",
                "shortDescription": "Permite que tus clientes elijan región y comuna en el carrito antes del checkout, con cobertura personalizable para Chile.",
                "iconName": "globe",
                "iconLetter": "D",
                "iconImage": "images/solutions/selector-de-comunas/hero.png",
                "gallery": [],
                "category": "operations",
                "tag": "Shipping",
                "views": "",
                "searchKeywords": "Selector de Comunas Permite que tus clientes elijan región y comuna en el carrito antes del checkout, con cobertura personalizable para Chile. shipping orders shopify native",
                "searchImage": "images/solutions/selector-de-comunas/hero.png",
                "searchExcerpt": "Permite que tus clientes elijan región y comuna en el carrito antes del checkout, con cobertura personalizable para Chile.",
                "featured": false,
                "showInHomeList": true,
                "showInSearch": true,
                "showInRelated": true,
                "homeListOrder": 99
            },
            {
                "slug": "blue-express",
                "title": "Blue Express Pyme",
                "subtitle": "Genera un archivo desde tus pedidos, súbelo a Blue Express y crea tus etiquetas de envío de forma rápida y fácil.",
                "description": "Selecciona los pedidos que quieres despachar y genera el archivo que Blue Express necesita para carga masiva. Súbelo a su plataforma y obtén tus etiquetas de envío en minutos, sin transcribir datos a mano ni preocuparte por el formato.",
                "shortDescription": "Genera un archivo desde tus pedidos, súbelo a Blue Express y crea tus etiquetas de envío de forma rápida y fácil.",
                "iconName": "order",
                "iconLetter": "D",
                "iconImage": "images/solutions/blue-express/hero.png",
                "gallery": [
                    "images/solutions/blue-express/screenshot-1.png",
                    "images/solutions/blue-express/screenshot-2.png",
                    "images/solutions/blue-express/screenshot-3.png"
                ],
                "category": "operations",
                "tag": "Shipping",
                "views": "",
                "searchKeywords": "Blue Express Pyme Genera un archivo desde tus pedidos, súbelo a Blue Express y crea tus etiquetas de envío de forma rápida y fácil. shipping orders",
                "searchImage": "images/solutions/blue-express/hero.png",
                "searchExcerpt": "Genera un archivo desde tus pedidos, súbelo a Blue Express y crea tus etiquetas de envío de forma rápida y fácil.",
                "featured": true,
                "showInHomeList": true,
                "showInSearch": true,
                "showInRelated": true,
                "homeListOrder": 1
            },
            {
                "slug": "general-discounts",
                "title": "Descuentos de envío",
                "subtitle": "Ofrece envío gratis o descuentos en el costo de despacho según ciudad, estado, productos o monto del pedido.",
                "description": "Crea descuentos automáticos que se aplican directamente a las opciones de envío en el checkout. Define envío gratis o rebajas por porcentaje o monto fijo según ciudad, estado, productos del carrito, peso o monto mínimo. Elige qué métodos de envío afecta cada regla y combínala con otros descuentos de Shopify. Todo configurable desde el admin y evaluado en checkout con precisión geográfica.",
                "shortDescription": "Ofrece envío gratis o descuentos en el costo de despacho según ciudad, estado, productos o monto del pedido.",
                "iconName": "discount",
                "iconLetter": "D",
                "iconImage": "images/solutions/general-discounts/hero.png",
                "gallery": [
                    "images/solutions/general-discounts/screenshot-1.png"
                ],
                "category": "sales",
                "tag": "Promotions",
                "views": "",
                "searchKeywords": "Descuentos de envío Ofrece envío gratis o descuentos en el costo de despacho según ciudad, estado, productos o monto del pedido. promotions shipping orders",
                "searchImage": "images/solutions/general-discounts/hero.png",
                "searchExcerpt": "Ofrece envío gratis o descuentos en el costo de despacho según ciudad, estado, productos o monto del pedido.",
                "featured": true,
                "showInHomeList": true,
                "showInSearch": true,
                "showInRelated": true,
                "homeListOrder": 1
            },
            {
                "slug": "delivery-rules",
                "title": "Reglas de entrega",
                "subtitle": "Controla las tarifas de envío en checkout: oculta, renombra, reordena y filtra métodos según condiciones avanzadas.",
                "description": "Define reglas lógicas para personalizar las opciones de envío en el checkout de tu tienda. Oculta tarifas según ubicación o monto del carrito, renombra métodos para comunicar mejor tus condiciones, reordena prioridades y combina condiciones WHEN/THEN sin tocar código. Ideal para operaciones con múltiples zonas, envíos gratis selectivos o tarifas diferenciadas por estado.",
                "shortDescription": "Controla las tarifas de envío en checkout: oculta, renombra, reordena y filtra métodos según condiciones avanzadas.",
                "iconName": "filter",
                "iconLetter": "D",
                "iconImage": "images/solutions/delivery-rules/hero.png",
                "gallery": [
                    "images/solutions/delivery-rules/screenshot-1.png",
                    "images/solutions/delivery-rules/screenshot-2.png",
                    "images/solutions/delivery-rules/screenshot-3.png"
                ],
                "category": "operations",
                "tag": "Shipping",
                "views": "",
                "searchKeywords": "Reglas de entrega Controla las tarifas de envío en checkout: oculta, renombra, reordena y filtra métodos según condiciones avanzadas. shipping orders automation workflow",
                "searchImage": "images/solutions/delivery-rules/hero.png",
                "searchExcerpt": "Controla las tarifas de envío en checkout: oculta, renombra, reordena y filtra métodos según condiciones avanzadas.",
                "featured": false,
                "showInHomeList": true,
                "showInSearch": true,
                "showInRelated": true,
                "homeListOrder": 99
            },
            {
                "slug": "boleta-factura",
                "title": "Boleta y Factura",
                "subtitle": "Permite que tus clientes elijan Boleta o Factura en el carrito y completen los datos tributarios antes del checkout.",
                "description": "Agrega un formulario nativo en el cart drawer y la página de carrito para que el comprador seleccione el tipo de documento y complete campos como RUT, razón social o email. Configura etiquetas, campos personalizados, validaciones y vista previa en tiempo real. Los datos se guardan en la información adicional del pedido para tu operación contable.",
                "shortDescription": "Permite que tus clientes elijan Boleta o Factura en el carrito y completen los datos tributarios antes del checkout.",
                "iconName": "file",
                "iconLetter": "F",
                "iconImage": "images/solutions/boleta-factura/hero.png",
                "gallery": [
                    "images/solutions/boleta-factura/screenshot-1.png",
                    "images/solutions/boleta-factura/screenshot-2.png",
                    "images/solutions/boleta-factura/screenshot-3.png"
                ],
                "category": "finance",
                "tag": "Documents",
                "views": "",
                "searchKeywords": "Boleta y Factura Permite que tus clientes elijan Boleta o Factura en el carrito y completen los datos tributarios antes del checkout. documents orders shopify native",
                "searchImage": "images/solutions/boleta-factura/hero.png",
                "searchExcerpt": "Permite que tus clientes elijan Boleta o Factura en el carrito y completen los datos tributarios antes del checkout.",
                "featured": false,
                "showInHomeList": true,
                "showInSearch": true,
                "showInRelated": true,
                "homeListOrder": 99
            },
            {
                "slug": "giftcard-rules",
                "title": "Reglas de Gift Card",
                "subtitle": "Oculta Gift Card en checkout cuando hay descuentos de producto, pedido o envío según las reglas que configures.",
                "description": "Define desde el admin cuándo ocultar Gift Card en el checkout según el tipo de descuento aplicado: producto, pedido o envío. Activa o desactiva las reglas con un switch y elige qué tipos bloquean el método de pago. La lógica se evalúa en tiempo real con una Shopify Function de personalización de pagos, sin tocar código.",
                "shortDescription": "Oculta Gift Card en checkout cuando hay descuentos de producto, pedido o envío según las reglas que configures.",
                "iconName": "payment",
                "iconLetter": "D",
                "iconImage": "images/solutions/giftcard-rules/hero.png",
                "gallery": [],
                "category": "sales",
                "tag": "Promotions",
                "views": "",
                "searchKeywords": "Reglas de Gift Card Oculta Gift Card en checkout cuando hay descuentos de producto, pedido o envío según las reglas que configures. promotions orders shopify native",
                "searchImage": "images/solutions/giftcard-rules/hero.png",
                "searchExcerpt": "Oculta Gift Card en checkout cuando hay descuentos de producto, pedido o envío según las reglas que configures.",
                "featured": false,
                "showInHomeList": true,
                "showInSearch": true,
                "showInRelated": true,
                "homeListOrder": 99
            },
            {
                "slug": "fechas-entrega",
                "title": "Fechas de Entrega",
                "subtitle": "Muestra una fecha de calendario exacta en el nombre de la tarifa de envío del checkout.",
                "description": "Configura calendarios por provincia con un día fijo de despacho y una hora de corte. En el checkout, la tarifa existente se renombra con la fecha calculada (por ejemplo, «Despacho a domicilio — miércoles 7 de octubre»). El reloj se inyecta desde el storefront y la fecha queda guardada en el pedido.",
                "shortDescription": "Muestra una fecha de calendario exacta en el nombre de la tarifa de envío del checkout.",
                "iconName": "automation",
                "iconLetter": "D",
                "iconImage": "images/solutions/fechas-entrega/hero.png",
                "gallery": [],
                "category": "operations",
                "tag": "Shipping",
                "views": "",
                "searchKeywords": "Fechas de Entrega Muestra una fecha de calendario exacta en el nombre de la tarifa de envío del checkout. shipping orders automation",
                "searchImage": "images/solutions/fechas-entrega/hero.png",
                "searchExcerpt": "Muestra una fecha de calendario exacta en el nombre de la tarifa de envío del checkout.",
                "featured": false,
                "showInHomeList": true,
                "showInSearch": true,
                "showInRelated": true,
                "homeListOrder": 99
            }
        ]
    },
    "en": {
        "apps": [
            {
                "slug": "tarifas-envio",
                "title": "Shipping rates",
                "subtitle": "Show different shipping prices by city or postal code at checkout—beyond Shopify's native state-level limit.",
                "description": "Shopify only supports shipping rates at the state level. With this app you define zones and subzones (cities or postal codes), create rates in your store, and filter at checkout which one applies based on the buyer's address. Configure manually or import thousands of prices via CSV. Ideal for detailed geographic coverage without relying only on external carriers.",
                "shortDescription": "Show different shipping prices by city or postal code at checkout—beyond Shopify's native state-level limit.",
                "iconName": "delivery",
                "iconLetter": "D",
                "iconImage": "images/solutions/tarifas-envio/hero.png",
                "gallery": [
                    "images/solutions/tarifas-envio/screenshot-1.png"
                ],
                "category": "operations",
                "tag": "Shipping",
                "views": "",
                "searchKeywords": "Shipping rates Show different shipping prices by city or postal code at checkout—beyond Shopify's native state-level limit. shipping orders",
                "searchImage": "images/solutions/tarifas-envio/hero.png",
                "searchExcerpt": "Show different shipping prices by city or postal code at checkout—beyond Shopify's native state-level limit.",
                "featured": true,
                "showInHomeList": true,
                "showInSearch": true,
                "showInRelated": true,
                "homeListOrder": 1
            },
            {
                "slug": "selector-de-comunas",
                "title": "Commune Selector",
                "subtitle": "Let customers choose region and commune in the cart before checkout, with customizable coverage for Chile.",
                "description": "Add a native region and commune selector in the cart drawer and cart page. Configure which communes you serve, customize the widget design, block checkout when commune is missing, and save the selection to cart attributes for shipping rates and fulfillment. Ideal for Chile stores that need to capture buyer location before calculating shipping.",
                "shortDescription": "Let customers choose region and commune in the cart before checkout, with customizable coverage for Chile.",
                "iconName": "globe",
                "iconLetter": "D",
                "iconImage": "images/solutions/selector-de-comunas/hero.png",
                "gallery": [],
                "category": "operations",
                "tag": "Shipping",
                "views": "",
                "searchKeywords": "Commune Selector Let customers choose region and commune in the cart before checkout, with customizable coverage for Chile. shipping orders shopify native",
                "searchImage": "images/solutions/selector-de-comunas/hero.png",
                "searchExcerpt": "Let customers choose region and commune in the cart before checkout, with customizable coverage for Chile.",
                "featured": false,
                "showInHomeList": true,
                "showInSearch": true,
                "showInRelated": true,
                "homeListOrder": 99
            },
            {
                "slug": "blue-express",
                "title": "Blue Express Pyme",
                "subtitle": "Generate a file from your orders, upload it to Blue Express, and create shipping labels quickly and easily.",
                "description": "Select the orders you want to ship and generate the file Blue Express requires for bulk upload. Upload it to their platform and get your shipping labels in minutes — no manual data entry or formatting headaches.",
                "shortDescription": "Generate a file from your orders, upload it to Blue Express, and create shipping labels quickly and easily.",
                "iconName": "order",
                "iconLetter": "D",
                "iconImage": "images/solutions/blue-express/hero.png",
                "gallery": [
                    "images/solutions/blue-express/screenshot-1.png",
                    "images/solutions/blue-express/screenshot-2.png",
                    "images/solutions/blue-express/screenshot-3.png"
                ],
                "category": "operations",
                "tag": "Shipping",
                "views": "",
                "searchKeywords": "Blue Express Pyme Generate a file from your orders, upload it to Blue Express, and create shipping labels quickly and easily. shipping orders",
                "searchImage": "images/solutions/blue-express/hero.png",
                "searchExcerpt": "Generate a file from your orders, upload it to Blue Express, and create shipping labels quickly and easily.",
                "featured": true,
                "showInHomeList": true,
                "showInSearch": true,
                "showInRelated": true,
                "homeListOrder": 1
            },
            {
                "slug": "general-discounts",
                "title": "Shipping discounts",
                "subtitle": "Offer free shipping or shipping cost discounts by city, state, products, or order amount.",
                "description": "Create automatic discounts applied directly to shipping options at checkout. Set free shipping or percentage/fixed-amount reductions based on city, state, cart products, weight, or minimum order value. Choose which shipping methods each rule affects and combine with other Shopify discounts. Fully configurable from the admin and evaluated at checkout with geographic precision.",
                "shortDescription": "Offer free shipping or shipping cost discounts by city, state, products, or order amount.",
                "iconName": "discount",
                "iconLetter": "D",
                "iconImage": "images/solutions/general-discounts/hero.png",
                "gallery": [
                    "images/solutions/general-discounts/screenshot-1.png"
                ],
                "category": "sales",
                "tag": "Promotions",
                "views": "",
                "searchKeywords": "Shipping discounts Offer free shipping or shipping cost discounts by city, state, products, or order amount. promotions shipping orders",
                "searchImage": "images/solutions/general-discounts/hero.png",
                "searchExcerpt": "Offer free shipping or shipping cost discounts by city, state, products, or order amount.",
                "featured": true,
                "showInHomeList": true,
                "showInSearch": true,
                "showInRelated": true,
                "homeListOrder": 1
            },
            {
                "slug": "delivery-rules",
                "title": "Delivery Rules",
                "subtitle": "Control checkout shipping rates: hide, rename, reorder, and filter methods with advanced conditions.",
                "description": "Define logical rules to customize shipping options at checkout. Hide rates by location or cart total, rename methods to communicate your conditions clearly, reorder priorities, and combine WHEN/THEN conditions without code. Ideal for multi-zone operations, selective free shipping, or state-specific rates.",
                "shortDescription": "Control checkout shipping rates: hide, rename, reorder, and filter methods with advanced conditions.",
                "iconName": "filter",
                "iconLetter": "D",
                "iconImage": "images/solutions/delivery-rules/hero.png",
                "gallery": [
                    "images/solutions/delivery-rules/screenshot-1.png",
                    "images/solutions/delivery-rules/screenshot-2.png",
                    "images/solutions/delivery-rules/screenshot-3.png"
                ],
                "category": "operations",
                "tag": "Shipping",
                "views": "",
                "searchKeywords": "Delivery Rules Control checkout shipping rates: hide, rename, reorder, and filter methods with advanced conditions. shipping orders automation workflow",
                "searchImage": "images/solutions/delivery-rules/hero.png",
                "searchExcerpt": "Control checkout shipping rates: hide, rename, reorder, and filter methods with advanced conditions.",
                "featured": false,
                "showInHomeList": true,
                "showInSearch": true,
                "showInRelated": true,
                "homeListOrder": 99
            },
            {
                "slug": "boleta-factura",
                "title": "Receipt & Invoice",
                "subtitle": "Let customers choose Receipt or Invoice in the cart and complete tax details before checkout.",
                "description": "Add a native form in the cart drawer and cart page so shoppers can select the document type and fill in fields such as tax ID, business name, or email. Configure labels, custom fields, validations, and a live preview. Data is saved to the order's additional information for your accounting workflow.",
                "shortDescription": "Let customers choose Receipt or Invoice in the cart and complete tax details before checkout.",
                "iconName": "file",
                "iconLetter": "F",
                "iconImage": "images/solutions/boleta-factura/hero.png",
                "gallery": [
                    "images/solutions/boleta-factura/screenshot-1.png",
                    "images/solutions/boleta-factura/screenshot-2.png",
                    "images/solutions/boleta-factura/screenshot-3.png"
                ],
                "category": "finance",
                "tag": "Documents",
                "views": "",
                "searchKeywords": "Receipt & Invoice Let customers choose Receipt or Invoice in the cart and complete tax details before checkout. documents orders shopify native",
                "searchImage": "images/solutions/boleta-factura/hero.png",
                "searchExcerpt": "Let customers choose Receipt or Invoice in the cart and complete tax details before checkout.",
                "featured": false,
                "showInHomeList": true,
                "showInSearch": true,
                "showInRelated": true,
                "homeListOrder": 99
            },
            {
                "slug": "giftcard-rules",
                "title": "Gift Card Rules",
                "subtitle": "Hide Gift Card at checkout when product, order, or shipping discounts are applied, based on rules you configure.",
                "description": "Define from the admin when to hide Gift Card at checkout based on the applied discount type: product, order, or shipping. Turn rules on or off with a switch and choose which types block the payment method. Logic is evaluated in real time via a Shopify payment customization function—no code required.",
                "shortDescription": "Hide Gift Card at checkout when product, order, or shipping discounts are applied, based on rules you configure.",
                "iconName": "payment",
                "iconLetter": "D",
                "iconImage": "images/solutions/giftcard-rules/hero.png",
                "gallery": [],
                "category": "sales",
                "tag": "Promotions",
                "views": "",
                "searchKeywords": "Gift Card Rules Hide Gift Card at checkout when product, order, or shipping discounts are applied, based on rules you configure. promotions orders shopify native",
                "searchImage": "images/solutions/giftcard-rules/hero.png",
                "searchExcerpt": "Hide Gift Card at checkout when product, order, or shipping discounts are applied, based on rules you configure.",
                "featured": false,
                "showInHomeList": true,
                "showInSearch": true,
                "showInRelated": true,
                "homeListOrder": 99
            },
            {
                "slug": "fechas-entrega",
                "title": "Delivery Dates",
                "subtitle": "Show an exact calendar date in the shipping rate name at checkout.",
                "description": "Configure per-province calendars with a fixed dispatch weekday and cutoff time. At checkout, the existing rate is renamed with the calculated date (for example, “Despacho a domicilio — miércoles 7 de octubre”). The storefront injects the clock and the date is stored on the order.",
                "shortDescription": "Show an exact calendar date in the shipping rate name at checkout.",
                "iconName": "automation",
                "iconLetter": "D",
                "iconImage": "images/solutions/fechas-entrega/hero.png",
                "gallery": [],
                "category": "operations",
                "tag": "Shipping",
                "views": "",
                "searchKeywords": "Delivery Dates Show an exact calendar date in the shipping rate name at checkout. shipping orders automation",
                "searchImage": "images/solutions/fechas-entrega/hero.png",
                "searchExcerpt": "Show an exact calendar date in the shipping rate name at checkout.",
                "featured": false,
                "showInHomeList": true,
                "showInSearch": true,
                "showInRelated": true,
                "homeListOrder": 99
            }
        ]
    }
};
    global.MELO_APPS_CATALOG = global.MELO_APPS_CATALOG_BY_LOCALE.es;
})(typeof window !== 'undefined' ? window : global);
